module.exports = __webpack_public_path__ + "static/media/attach_file.04db1d4b.svg";